/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleAllocationProportionalUsage extends models.BillingRuleAllocationGenericTargets {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleAllocationProportionalUsage");
    }

    getFixupPrototypeFunction() { return BillingRuleAllocationProportionalUsage.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleAllocationProportionalUsage>): BillingRuleAllocationProportionalUsage {
        let obj = Object.assign(new BillingRuleAllocationProportionalUsage(), model);
        BillingRuleAllocationProportionalUsage.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleAllocationProportionalUsage>): BillingRuleAllocationProportionalUsage {
        if (!model) return null;
        return BillingRuleAllocationProportionalUsage.newInstance(<BillingRuleAllocationProportionalUsage> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleAllocationProportionalUsage) {
        if (!obj) return;

        models.BillingRuleAllocationProportionalUsage.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleAllocationProportionalUsage): boolean {
        if (models.BillingRuleAllocationGenericTargets.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleAllocationProportionalUsage.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
